import { render, staticRenderFns } from "./EpisodeItem.vue?vue&type=template&id=f535754c&scoped=true&"
import script from "./EpisodeItem.vue?vue&type=script&lang=js&"
export * from "./EpisodeItem.vue?vue&type=script&lang=js&"
import style0 from "./EpisodeItem.vue?vue&type=style&index=0&id=f535754c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f535754c",
  null
  
)

export default component.exports